import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1013b562"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

import { ref, nextTick, onUpdated, onBeforeUpdate } from "vue";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { useEventListener } from "@vueuse/core";

interface Props {
  /** two-way bound open state */
  modelValue?: boolean;
  /** modal aria label */
  label: string;
}

interface Emits {
  /** two-way bound open state */
  (event: "update:modelValue", value: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    modelValue: { type: Boolean },
    label: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  /** two-way bound open state */
  (event: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  /** two-way bound open state */
  modelValue?: boolean;
  /** modal aria label */
  label: string;
}





/** element that had focus before modal was opened */
const originalFocus = ref<HTMLElement | null>(null);

/** update model value to close modal */
function close() {
  emit("update:modelValue", false);
}

/** when user presses any key */
function keyDown(event: KeyboardEvent) {
  if (event.key === "Escape") close();
}

/** attach key down listener to window */
useEventListener(window, "keydown", keyDown);

/** modal element */
const modal = ref<HTMLElement>();

/** after state change */
onUpdated(() => {
  /** rest of app besides modal */
  const app = document?.querySelector("#app");

  /** if modal just opened */
  if (props.modelValue) {
    /** hide for screen readers */
    app?.setAttribute("aria-hidden", "true");
    /** disable focus */
    app?.setAttribute("inert", "true");
    /** disable body scroll */
    if (modal.value) disableBodyScroll(modal.value);
    /** focus first focusable element in modal */
    const query = "input, textarea, button, select";
    const focusable = modal.value?.querySelector(query) as HTMLElement;
    focusable?.focus();
  }
});

/** before state change */
onBeforeUpdate(async () => {
  /** rest of app besides modal */
  const app = document?.querySelector("#app");

  /** if modal about to be opened */
  if (props.modelValue) {
    originalFocus.value = document?.activeElement as HTMLElement;
  } else {
    /** if modal about to be closed */
    /** show for screen readers */
    app?.removeAttribute("aria-hidden");
    /** enable focus */
    app?.removeAttribute("inert");
    /** enable body scroll */
    if (modal.value) enableBodyScroll(modal.value);
    /** restore focus to what had focus before modal opened */
    await nextTick();
    originalFocus.value?.focus();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "overlay",
              onMousedown: close,
              onTouchstart: close
            }, [
              _createElementVNode("div", {
                ref_key: "modal",
                ref: modal,
                class: "modal",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": __props.label,
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onTouchstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _withDirectives(_createVNode(_component_AppButton, {
                  class: "close",
                  design: "circle",
                  icon: "times",
                  onClick: close
                }, null, 512), [
                  [_directive_tooltip, 'Close dialog (esc)']
                ]),
                _renderSlot(_ctx.$slots, "default")
              ], 40, _hoisted_1)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})